import {
	SET_IS_LOADING,
	SET_LAYOUT_ZOOM,
	INCREMENT_LAYOUT_ZOOM,
	DECREMENT_LAYOUT_ZOOM,
} from "redux/constants/Gui";

const clampZoom = (v) => Math.min(130, Math.max(75, v));

const initGui = {
	isLoading: false,
	layoutZoom: 100,
};

const gui = (state = initGui, action) => {
	switch (action.type) {
		case SET_IS_LOADING:
			return {
				...state,
				isLoading: action.isLoading,
			};
		case SET_LAYOUT_ZOOM:
			return {
				...state,
				layoutZoom: clampZoom(Number(action.payload) || 100),
			};
		case INCREMENT_LAYOUT_ZOOM:
			return {
				...state,
				layoutZoom: clampZoom(state.layoutZoom + 5),
			};
		case DECREMENT_LAYOUT_ZOOM:
			return {
				...state,
				layoutZoom: clampZoom(state.layoutZoom - 5),
			};
		default:
			return state;
	}
};

export default gui;
